import IAppState from 'infrastructure/store/IAppState';
import React, { ReactNode } from 'react'
import { useSelector } from 'react-redux';
import { UserState } from 'redux-oidc';
import { UserRole } from './userRole';

type Props = {
  children: ReactNode;
  enabledRoles: UserRole | UserRole[];
  unauthorizedRender?: () => JSX.Element;
}

const OidcRolesChecker = ({ children, enabledRoles, unauthorizedRender }: Props) => {
  // store
  const user = useSelector<IAppState, UserState>((store) => store.oidc).user;

  const hasUserEnabledRole = (): boolean => {
    let hasRole = false;
    
    if (user && user.profile.role) {
      let userRole: string = user.profile.role;

      if (Array.isArray(enabledRoles)) {
        let foundRole = enabledRoles.find(x => x === userRole);

        if (foundRole !== undefined) {
          hasRole = true;
        }
      } else {
        hasRole = enabledRoles === userRole;
      }
    }

    return hasRole;
  }

  // render
  if (hasUserEnabledRole()) {
    return (
      <>
        {children}
      </>
    );
  } else if (unauthorizedRender) {
    return unauthorizedRender();
  } else {
    return null;
  }
}

export default OidcRolesChecker